
export default function() {
  
  $(".elastic-btn").each(function() {
    var $this=$(this);
    var w=$this.innerWidth();
    var h=$this.innerHeight();
    var svg=document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute("class", "eb");
    svg.setAttribute("width", w*1.4);
    svg.setAttribute("height", h*1.4);
    svg.setAttribute("viewBox", `${-0.2*w} ${-0.2*h} ${1.4*w} ${1.4*h}`);
    var path=document.createElementNS('http://www.w3.org/2000/svg', 'path');
    svg.appendChild(path);
    $this.append(svg);
    var curveArg=0;
    var setCurveArg=function(arg) {
      curveArg=arg;
      var a=arg*50;
      path.setAttribute("d",
        "M 0 0 "+
        `C 0 ${-a} ${w} ${-a} ${w} 0`+
        `C ${w+a} 0 ${w+a} ${h} ${w} ${h} `+
        `C ${w} ${h+a} 0 ${h+a} 0 ${h} `+
        `C ${-a} ${h} ${-a} 0 0 0`+
        "Z");
    };
    setCurveArg(0);
    var animInProgress=0;
    var animOutProgress=0;
    var animInInterval=null;
    var animOutInterval=null;
    var animIn=function() {
      animInProgress=0;
      animInInterval && clearInterval(animInInterval);
      animOutInterval && clearInterval(animOutInterval);
      animOutInterval=null;
      animInInterval=setInterval(animInStep, 16);
    }
    var animOut=function() {
      animOutProgress=0;
      animInInterval && clearInterval(animInInterval);
      animOutInterval && clearInterval(animOutInterval);
      animInInterval=null;
      animOutInterval=setInterval(animOutStep, 16);
    }
    var animInStep=function() {
      animInProgress+=1;
      if (animInProgress>=10) {
        clearInterval(animInInterval);
        animInInterval=null;
      }
      var progress=animInProgress/10;
      progress=1-(1-progress)*(1-progress);
      setCurveArg(progress*.15);
    }
    var animOutStep=function() {
      animOutProgress+=1;
      if (animOutProgress>=20) {
        clearInterval(animOutInterval);
        animOutInterval=null;
      }
      var progress=animOutProgress/10;
      if (progress>1) {
        progress-=1;
        progress*=2;
        if (progress>1)
          progress=2-progress;
        progress=progress+1;
      }
      // console.log(progress);
      progress=/*Math.abs(1-progress)**/(1-progress);
      setCurveArg(progress*.15);
    }
    $this.mousedown(function() {
      animIn();
    }).mouseup(function() {
      animOut();
    });
  });
  
  $(".sec-nav .sec-nav-main").each(function() {
    var $this=$(this);
    var w=200;
    var h=200;
    var svg=document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute("class", "eb");
    svg.setAttribute("width", w);
    svg.setAttribute("height", h);
    svg.setAttribute("viewBox", `0 0 ${w} ${h}`);
    svg.setAttribute("preserveAspectRatio", "none");
    var path=document.createElementNS('http://www.w3.org/2000/svg', 'path');
    svg.appendChild(path);
    $this.append(svg);
    var curveArg=0;
    var setCurveArg=function(arg) {
      curveArg=arg;
      var a=arg*7;
      path.setAttribute("d",
        "M 0 0 "+
        `C 0 0 ${w} 0 ${w} 0`+
        `C ${w-a} 0 ${w-a} ${h} ${w} ${h} `+
        `C ${w} ${h} 0 ${h} 0 ${h} `+
        `C ${a} ${h} ${a} 0 0 0`+
        "Z");
    };
    setCurveArg(0);
//     $this.prepend(svg);
    var ul=$this.find(">ul");
    var step=0;
    var target=0;
    $this.find(".current").click(function(e) {
      e.preventDefault();
      animateToggle();
    });
    var animateInterval=null;
    var animateToggle=function() {
      if (step==0)
        target=1;
      else
        target=0;
      clearInterval(animateInterval);
      animateInterval=setInterval(animateStep, 16);
    };
    var animateStep=function() {
      if (target==1 && step<1) {
        step+=0.05;
      }
      if (target==1 && step>=1) {
        step=1;
        clearInterval(animateInterval);
      }
      if (target==0 && step>0) {
        step-=0.05;
      }
      if (target==0 && step<=0) {
        step=0;
        clearInterval(animateInterval);
      }
      if (target==1)
        $this.addClass("open");
      if (target==0)
        $this.removeClass("open");
      var easeStep=(step<=0.5?step*step*2:1-(1-step)*(1-step)*2);
      var curveStep=1-Math.pow(Math.abs(step-0.5)*2, 2);
      ul.css("height", ul[0].scrollHeight*easeStep);
      $(svg).css("height", ul[0].scrollHeight*easeStep+$this.innerHeight());
      setCurveArg(curveStep);
    };
  });
  
  $(".news-list-head .select").each(function() {
    var $this=$(this);
    var w=200;
    var h=200;
    var svg=document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute("class", "eb");
    svg.setAttribute("width", w);
    svg.setAttribute("height", h);
    svg.setAttribute("viewBox", `0 0 ${w} ${h}`);
    svg.setAttribute("preserveAspectRatio", "none");
    var path=document.createElementNS('http://www.w3.org/2000/svg', 'path');
    svg.appendChild(path);
    $this.append(svg);
    var curveArg=0;
    var setCurveArg=function(arg) {
      curveArg=arg;
      var a=arg*7;
      path.setAttribute("d",
        "M 0 0 "+
        `C 0 0 ${w} 0 ${w} 0`+
        `C ${w-a} 0 ${w-a} ${h} ${w} ${h} `+
        `C ${w} ${h} 0 ${h} 0 ${h} `+
        `C ${a} ${h} ${a} 0 0 0`+
        "Z");
    };
    setCurveArg(0);
//     $this.prepend(svg);
    var ul=$this.find(">ul");
    var step=0;
    var target=0;
    $this.find(".current").click(function(e) {
      e.preventDefault();
      animateToggle();
    });
    $this.find("ul li").click(function(e) {
      e.preventDefault();
      animateToggle();
    });
    var animateInterval=null;
    var animateToggle=function() {
      if (step==0)
        target=1;
      else
        target=0;
      clearInterval(animateInterval);
      animateInterval=setInterval(animateStep, 16);
    };
    var animateStep=function() {
      if (target==1 && step<1) {
        step+=0.05;
      }
      if (target==1 && step>=1) {
        step=1;
        clearInterval(animateInterval);
      }
      if (target==0 && step>0) {
        step-=0.05;
      }
      if (target==0 && step<=0) {
        step=0;
        clearInterval(animateInterval);
      }
      if (target==1)
        $this.addClass("open");
      if (target==0)
        $this.removeClass("open");
      var easeStep=(step<=0.5?step*step*2:1-(1-step)*(1-step)*2);
      var curveStep=1-Math.pow(Math.abs(step-0.5)*2, 2);
      ul.css("height", ul[0].scrollHeight*easeStep);
      $(svg).css("height", ul[0].scrollHeight*easeStep+$this.innerHeight());
      setCurveArg(curveStep);
    };
  });
  
}
